<template>
  <v-container grid-list-md pt-0 pb-0>
    <!-- <div class="" v-if="listPlantKnowledge.length === 0">
    ไม่มีข้อมูล
  </div> -->
    <div style="margin-top:17rem !important" v-if="isLoadingMain">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div>

    <div class="" v-if="!isLoadingMain && listPlantKnowledge.length !== 0">
      <template>
        <v-layout row wrap justify-center align-center>
          <v-flex md6>
            <v-text-field
              v-model="search"
              label="Search..."
              solo
              hide-details
              clearable
              clear-icon="mdi-close-circle-outline"
              append-icon="search"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="" v-if="this.search !== ''">
          <v-layout row wrap mt-3>
            <v-flex
              xs6
              sm4
              md3
              v-for="(d, index) in filteredList"
              :key="index"
              d-flex
            >
              <v-card
                color="white"
                class="black--text"
                hover
                :href="d.plant_link !== '' ? d.plant_link : ''"
                target="_blank"
                :class="d.plant_link !== '' ? 'pointer' : 'no_pointer'"
              >
                <v-layout row wrap align-center justify-center>
                  <v-flex xs6 md6 d-flex>
                    <v-card-title primary-title class="pl-0">
                      <div>
                        <div class="title">{{ d.plant_province }}</div>
                        <div
                          class="title font-weight-bold"
                          style="font-size: 18px !important;"
                        >
                          {{ d.plant_knowledge_name }}
                        </div>
                      </div>
                    </v-card-title>
                  </v-flex>
                  <v-flex xs5 md5 offset-md-1>
                    <v-card-text style="padding: 4px !important">
                      <v-img
                        :src="getImgUrl(d.plant_topic_id, d.plant_image)"
                        aspect-ratio="1"
                      ></v-img>
                    </v-card-text>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </div>

        <v-layout row wrap v-if="filteredList.length === 0" justify-center mt-2>
          <v-flex xs12 md12>
            <h2>ไม่พบข้อมูล</h2>
          </v-flex>
        </v-layout>

        <div class="" v-if="this.search === ''">
          <v-tabs color="none" light slider-color="yellow" class="mt-4 mb-3">
            <v-tab
              v-for="(n, index) in listPlantKnowledge"
              :key="index"
              :href="`#tab-${n.plant_topic_id}`"
              @click="queryPlantByTopic(n.plant_topic_id)"
            >
              {{ n.plant_topic_name }}
            </v-tab>
            <v-tabs-items>
              <v-tab-item value="tab-1">
                <div
                  style="margin-top:17rem !important"
                  v-if="!isLoading && listPlantByTopic.length === 0"
                >
                  <v-layout
                    row
                    wrap
                    flex
                    justify-center
                    align-center
                    fill-height
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-layout>
                </div>
                <v-layout
                  row
                  wrap
                  mt-3
                  v-for="(d, index) in listPlantByTopic"
                  :key="index"
                >
                  <v-flex md12
                    ><span
                      class="title font-weight-bold"
                      style="color:#3939de !important; font-size:16px;"
                      >ต้นไม้ทรงปลูกใน {{ d.name }}</span
                    ></v-flex
                  >
                  <v-flex
                    md12
                    class="subheading pt-0"
                    v-if="
                      d.name ===
                        'สมเด็จพระกนิษฐาธิราชเจ้า กรมสมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี'
                    "
                  >
                    (ข้อมูลจากหนังสือ : 60 ต้นไม้ทรงปลูกในสมเด็จพระเทพฯ.
                    โครงการพัฒนาป่าไม้ ศูนย์ศึกษาพัฒนาอ่าวคุ้งกระเบน
                    อันเนื่องมาจากพระราชดำริ จังหวัดจันทบุรี. กรมป่าไม้, 2557)
                  </v-flex>
                  <v-flex md12 v-else class="subheading pt-0">
                    (ข้อมูลจากหนังสือ : ต้นไม้ทรงปลูกในรัชกาลที่ 9. กรมป่าไม้,
                    2560)
                  </v-flex>
                  <v-flex
                    xs6
                    sm4
                    md3
                    v-for="(p, index) in d.plant"
                    :key="index"
                  >
                    <v-layout row wrap mt-1>
                      <v-flex xs12 sm12 md12>
                        <v-card
                          color="white"
                          class="black--text"
                          hover
                          :href="p.plant_link !== '' ? p.plant_link : ''"
                          target="_blank"
                          :class="
                            p.plant_link !== '' ? 'pointer' : 'no_pointer'
                          "
                        >
                          <v-layout row wrap align-center justify-center>
                            <v-flex xs6 md6 d-flex>
                              <v-card-title primary-title class="pl-0">
                                <div>
                                  <div
                                    class="title font-weight-bold"
                                    style="font-size: 18px !important;"
                                  >
                                    {{ p.plant_knowledge_name }}
                                  </div>
                                </div>
                              </v-card-title>
                            </v-flex>
                            <v-flex xs5 md5 offset-md-1>
                              <v-card-text style="padding: 4px !important">
                                <v-img
                                  :src="
                                    getImgUrl(p.plant_topic_id, p.plant_image)
                                  "
                                  aspect-ratio="1"
                                ></v-img>
                              </v-card-text>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-if="listPlantByTopic.length === 0"
                  justify-center
                  mt-4
                  style="text-align:center"
                >
                  <v-flex xs12 md12>
                    <h2>กำลังดำเนินการปรับปรุงข้อมูล</h2>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              <v-tab-item value="tab-2">
                <div
                  style="margin-top:17rem !important"
                  v-if="!isLoading && listPlantByTopic.length === 0"
                >
                  <v-layout
                    row
                    wrap
                    flex
                    justify-center
                    align-center
                    fill-height
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-layout>
                </div>
                <v-layout row wrap mt-3>
                  <v-flex
                    xs6
                    sm4
                    md3
                    v-for="(d, index) in listPlantByTopic"
                    :key="index"
                    d-flex
                  >
                    <v-card
                      color="white"
                      class="black--text"
                      hover
                      :href="d.plant_link !== '' ? d.plant_link : ''"
                      target="_blank"
                      :class="d.plant_link !== '' ? 'pointer' : 'no_pointer'"
                    >
                      <v-layout row wrap align-center justify-center>
                        <v-flex xs6 md6 d-flex>
                          <v-card-title primary-title class="pl-0">
                            <div>
                              <div
                                class="title mb-2"
                                style="font-size: 14px !important;"
                              >
                                {{ d.plant_province }}
                              </div>
                              <div
                                class="title font-weight-bold"
                                style="font-size: 18px !important;"
                              >
                                {{ d.plant_knowledge_name }}
                              </div>
                            </div>
                          </v-card-title>
                        </v-flex>
                        <v-flex xs5 md5 offset-md-1>
                          <v-card-text style="padding: 4px !important">
                            <v-img
                              :src="getImgUrl(d.plant_topic_id, d.plant_image)"
                              aspect-ratio="1"
                            ></v-img>
                          </v-card-text>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item value="tab-3">
                <div
                  style="margin-top:17rem !important"
                  v-if="!isLoading && listPlantByTopic.length === 0"
                >
                  <v-layout
                    row
                    wrap
                    flex
                    justify-center
                    align-center
                    fill-height
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-layout>
                </div>
                <v-layout row wrap mt-3>
                  <v-flex
                    xs6
                    sm4
                    md3
                    v-for="(d, index) in listPlantByTopic"
                    :key="index"
                    d-flex
                  >
                    <v-card
                      color="white"
                      class="black--text"
                      hover
                      :href="d.plant_link !== '' ? d.plant_link : ''"
                      target="_blank"
                      :class="d.plant_link !== '' ? 'pointer' : 'no_pointer'"
                    >
                      <v-layout row wrap align-center justify-center>
                        <v-flex xs6 md6 d-flex>
                          <v-card-title primary-title class="pl-0">
                            <div>
                              <div
                                class="title"
                                style="font-size: 14px !important;"
                              >
                                {{ d.plant_province }}
                              </div>
                              <div
                                class="title font-weight-bold"
                                style="font-size: 18px !important;"
                              >
                                {{ d.plant_knowledge_name }}
                              </div>
                            </div>
                          </v-card-title>
                        </v-flex>
                        <v-flex xs5 md5 offset-md-1>
                          <v-card-text style="padding: 4px !important">
                            <v-img
                              :src="getImgUrl(d.plant_topic_id, d.plant_image)"
                              aspect-ratio="1"
                            ></v-img>
                          </v-card-text>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-if="listPlantByTopic.length === 0"
                  justify-center
                  mt-4
                  style="text-align:center"
                >
                  <v-flex xs12 md12>
                    <h2>กำลังดำเนินการปรับปรุงข้อมูล</h2>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item value="tab-4">
                <v-layout row wrap mt-3>
                  <v-flex
                    xs6
                    sm4
                    md3
                    v-for="(d, index) in listPlantByTopic"
                    :key="index"
                    d-flex
                  >
                    <v-card
                      color="white"
                      class="black--text"
                      hover
                      :href="d.plant_link !== '' ? d.plant_link : ''"
                      target="_blank"
                      :class="d.plant_link !== '' ? 'pointer' : 'no_pointer'"
                    >
                      <v-layout row wrap align-center justify-center>
                        <v-flex xs6 md6 d-flex>
                          <v-card-title primary-title class="pl-0">
                            <div>
                              <div
                                class="title"
                                style="font-size: 14px !important;"
                              >
                                {{ d.plant_province }}
                              </div>
                              <div
                                class="title font-weight-bold"
                                style="font-size: 18px !important;"
                              >
                                {{ d.plant_knowledge_name }}
                              </div>
                            </div>
                          </v-card-title>
                        </v-flex>
                        <v-flex xs5 md5 offset-md-1>
                          <v-card-text style="padding: 4px !important">
                            <v-img
                              :src="getImgUrl(d.plant_topic_id, d.plant_image)"
                              aspect-ratio="1"
                            ></v-img>
                          </v-card-text>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-if="listPlantByTopic.length === 0"
                  justify-center
                  mt-4
                  style="text-align:center"
                >
                  <v-flex xs12 md12>
                    <h2>กำลังดำเนินการปรับปรุงข้อมูล</h2>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div>
      </template>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      active: "",
      search: "",
      listPlantKnowledge: [],
      isLoading: true,
      isLoadingMain: true,
      listPlantByTopic: [],
      listPlantSearch: [],
      plant_topic_id: 1,
    };
  },
  created() {
    this.queryPlantKnowledge();
    this.queryPlantByTopic("1");
    this.queryPlantSearch();
  },
  mounted() {
    this.queryPlantByTopic("1");
  },
  computed: {
    filteredList() {
      return this.listPlantSearch.filter((post) => {
        return (post.plant_knowledge_name + post.plant_province)
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    queryPlantSearch() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryPlantSearch")
        .then((response) => {
          // console.log(response.data);
          this.listPlantSearch = response.data;
        });
    },
    queryPlantByTopic(plant_topic_id) {
      // console.log(plant_topic_id);
      this.isLoading = true;
      this.listPlantByTopic = [];
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryPlantByTopic", {
          plant_topic_id: plant_topic_id,
        })
        .then((response) => {
          // console.log(response.data);
          this.listPlantByTopic = response.data;
          this.isLoading = false;
        });
    },
    queryPlantKnowledge() {
      this.isLoadingMain = true;
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryPlantKnowledge")
        .then((response) => {
          // console.log(response.data);
          this.listPlantKnowledge = response.data;
          this.isLoadingMain = false;
        });
    },
    getImgUrl(id, image) {
      if (id === undefined || image === undefined) {
        return;
      } else {
        return require("../assets/images/plant-knowledge/" + id + "/" + image);
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 320px) {
  .title {
    font-size: 16px !important;
  }
}
</style>
